import { render, staticRenderFns } from "./excel-template.vue?vue&type=template&id=37b6c6f6&scoped=true"
import script from "./excel-template.vue?vue&type=script&lang=js"
export * from "./excel-template.vue?vue&type=script&lang=js"
import style0 from "./excel-template.vue?vue&type=style&index=0&id=37b6c6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6c6f6",
  null
  
)

export default component.exports